// ** Redux Imports
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
// ** Axios Imports
import axios from 'axios'
import {imageUrlToBase64} from "../../../../utility/Utils";

export const setLoading = createAsyncThunk('PurchaseRequestCustomization/setLoading', async (loadingState) => ({ ...loadingState }))

export const getData = createAsyncThunk('PurchaseRequestCustomization/getData', async (params, { dispatch }) => {
    dispatch(setLoading({ getData: true }))
    const response = await axios.get('/InvoicePreviewCustomization/GetPurchaseRequestCustomization', { params })
    dispatch(setLoading({ getData: false }))
    if(response.data.data.signatureImage) {
        try {
            response.data.data.signatureImageBase64 = await imageUrlToBase64(process.env.REACT_APP_API_URL_production + response.data.data.signatureImage);
        } catch(error) {
            console.log(error);
        }
    }
    return {
        params,
        data: response.data,
    }
})

export const getBank = createAsyncThunk('PurchaseRequestCustomization/getBank', async (params, { dispatch }) => {
    dispatch(setLoading({ getData: true }))
    const response = await axios.get('/Locations/GetBankDetails', { params })
    dispatch(setLoading({ getData: false }))
    return {
        params,
        data: response.data,
    }
})

export const PurchaseRequestCustomizationSlice = createSlice({
    name: 'PurchaseRequestCustomization',
    initialState: {
        data: {},
        bank_data: {},
        params: {},
        loadingState: { getData: false }
        // allData: []
    },
    reducers: {},
    extraReducers: builder => {
        builder
            .addCase(getData.fulfilled, (state, action) => {
                state.data = action.payload.data.data
                state.params = action.payload.params
            })
            .addCase(getBank.fulfilled, (state, action) => {
                state.bank_data = action.payload.data.data
                state.params = action.payload.params
            })
            .addCase(setLoading.fulfilled, (state, action) => {
                state.loadingState = action.payload
            })
    }
})

export default PurchaseRequestCustomizationSlice.reducer
